"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    $scrollTo: true,
    type: "Browser",
    cssBlockName: "block-browser",
};
